import { useTranslation } from 'react-i18next'
import { LocaleForm } from '~/features/auth/LocaleForm'
import { LoginForm } from '~/features/auth/login'
import { Wrapper, Title } from './styled'

export function AuthForms() {
  const { t } = useTranslation()
  return (
    <Wrapper>
      <Title>{t('authorization')}</Title>

      <LoginForm />

      <LocaleForm />
    </Wrapper>
  )
}
